export const BUDGET2024_PAGE_SIZE = 10;
export const BUDGET2024_PAGE_QUERY = "/keywords/singapore-budget-2024";
export const BUDGET2024_LATEST_NEWS_TOTAL_SIZE = 15;
export const BUDGET2024_LATEST_NEWS_SIZE = 3;
export const BUDGET2024_INFOGRAPHICS_LINK =
  "https://static1.businesstimes.com.sg/bt_files/specials/singapore-budget-2024/singapore-budget-revenue-and-spending-breakdown-2024/index.html";
export const BUDGET2024_MTI_BOOKLET =
  "https://static1.businesstimes.com.sg/s3fs-public/2024-03/mti_business_budget_booklet_english.pdf";
